// Internal communications between iframes

import { BroadcastChannel } from 'broadcast-channel'

const InternalCommunication = (channelId) => new BroadcastChannel(channelId, {
    webWorkerSupport: false,
})

export default InternalCommunication
